import { render, staticRenderFns } from "./UserInformationWidget.vue?vue&type=template&id=3a434bee&scoped=true"
import script from "./UserInformationWidget.vue?vue&type=script&lang=js"
export * from "./UserInformationWidget.vue?vue&type=script&lang=js"
import style0 from "./UserInformationWidget.vue?vue&type=style&index=0&id=3a434bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a434bee",
  null
  
)

export default component.exports